import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { convertArrayToObject } from "../../helpers/catalog-helper";

export interface AccountsState {
  accountsData: {};
  accountsDataUsingName: Record<string, any>;
}

const initialState: AccountsState = {
  accountsData: {},
  accountsDataUsingName: {}
};

export const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    getAllAccountsData: (state) => {},
    saveAllAccountsData: (state, actions) => {
      if (actions.payload) {
        state.accountsData = convertArrayToObject(actions.payload, "mid");
        state.accountsDataUsingName = convertArrayToObject(actions.payload, "name", false);
      }
      // state.accountsData = actions.payload
      //   ? convertArrayToObject(actions.payload, "mid")
      //   : {};
    },
    deleteAccountData: (state, actions) => {},
    saveAccountData: (state, actions) => {},
  },
});

export const {
  getAllAccountsData,
  saveAllAccountsData,
  deleteAccountData,
  saveAccountData,
} = accountsSlice.actions;
export default accountsSlice.reducer;
